import { render, staticRenderFns } from "./Functionalities.vue?vue&type=template&id=123339d9"
import script from "./Functionalities.vue?vue&type=script&lang=js"
export * from "./Functionalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports